import { render, staticRenderFns } from "./VsScenarioRow.vue?vue&type=template&id=204b0984&scoped=true&"
import script from "./VsScenarioRow.vue?vue&type=script&lang=js&"
export * from "./VsScenarioRow.vue?vue&type=script&lang=js&"
import style0 from "./VsScenarioRow.vue?vue&type=style&index=0&id=204b0984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b0984",
  null
  
)

export default component.exports